var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"container pb-5 text-center"},[_c('SectionTitle',{attrs:{"title":"Organigrama"}}),_c('br'),_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/quienesSomos/organigrama.png"),"alt":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }